import { useMemo } from 'react'
import { RoomSession } from '../../../models/Room'
import { Log, LoggerType } from '../../../common/logger'
import { env } from '../../../common/util'

export const useLoggerConfig = (accountId: string, roomSession: RoomSession) => {
  const loggerConfig = useMemo(() => {
    const levels = env === 'prod' ? ['error'] : ['debug', 'error', 'info', 'warn']
    return {
      traceId: `in-person-meeting-${accountId}-${roomSession.roomId}-${roomSession.id}`,
      loggers: ['db'] as LoggerType[],
      logToConsole: true,
      logLevelsToConsole: levels as Log['level'][],
      fallbackLoggerEnabled: true,
      showDebugWindow: false,
    }
  }, [accountId, roomSession.roomId, roomSession.id])

  return {
    loggerConfig,
  }
}
